/** Matches the whitespace/trim normalization the store applies to titles, for uniqueness checks. */
export function normalizeCollectionNameForCompare(value: string): string {
  return value.trim().replace(/\s+/g, ' ').toLowerCase();
}

/** True when `name` collides with an existing collection name (case-insensitive, trimmed). */
export function isCollectionNameTaken(name: string, existingNames: Iterable<string>): boolean {
  const needle = normalizeCollectionNameForCompare(name);
  if (needle === '') return false;
  for (const existing of existingNames) {
    if (normalizeCollectionNameForCompare(existing) === needle) return true;
  }
  return false;
}
